import apiClient from "@/shared/services/apiClient";

const API_VERSION = 2;
const RESOURCE_URL = "/api/tabelafrete";
const LIST_URL = RESOURCE_URL + "/listagem";
const STORE_FIRST_URL = RESOURCE_URL + "/store-first";
const SUPPLIER_SEARCH_URL = "/api/pessoa/jsonlist/fornecedor";
const BATCH_APPROVE_URL = RESOURCE_URL + "/store/aprovacaolote";
const BATCH_CANCEL_URL = RESOURCE_URL + "/store/cancelamentolote";
const VALIDITY_APPROVE_URL = "/api/tabelafretevig/store/aprovacao";
const VALIDITY_CANCEL_URL = "/api/tabelafretevig/store/cancelamento";

export default {
  // Listagem da tela nova: payload enxuto, contrato próprio.
  fetchList(params = {}) {
    return apiClient.get(LIST_URL, { params, apiVersion: API_VERSION });
  },

  // Uma tabela com a árvore inteira, no formato cru que o mapper do Detalhes lê.
  fetchOne(tabfreId) {
    return apiClient.get(RESOURCE_URL + "/" + tabfreId, {
      apiVersion: API_VERSION,
    });
  },

  fetchDomainOptions() {
    return apiClient.get(RESOURCE_URL + "/jsonlistgeral", {
      apiVersion: API_VERSION,
    });
  },

  saveConfigRoutes(payload) {
    return apiClient.put(RESOURCE_URL + "/store", payload, {
      apiVersion: API_VERSION,
    });
  },

  searchSuppliers(search) {
    return apiClient.post(
      SUPPLIER_SEARCH_URL,
      { search },
      { apiVersion: API_VERSION },
    );
  },

  storeFirst(payload) {
    return apiClient.post(STORE_FIRST_URL, payload, {
      apiVersion: API_VERSION,
    });
  },

  fetchDraft(tabfreId) {
    return apiClient.get(STORE_FIRST_URL + "/" + tabfreId, {
      apiVersion: API_VERSION,
    });
  },

  finalizeDraft(tabfreId) {
    return apiClient.post(
      STORE_FIRST_URL + "/" + tabfreId + "/finalizar",
      {},
      { apiVersion: API_VERSION },
    );
  },

  updateFirst(tabfreId, payload) {
    return apiClient.put(STORE_FIRST_URL + "/" + tabfreId, payload, {
      apiVersion: API_VERSION,
    });
  },

  remove(tabfreId) {
    return apiClient.delete(STORE_FIRST_URL + "/" + tabfreId, {
      apiVersion: API_VERSION,
    });
  },

  approveTablesValidities(freightTableIds) {
    return apiClient.post(
      BATCH_APPROVE_URL,
      { vig: freightTableIds.map((id) => ({ id: Number(id) })) },
      { apiVersion: API_VERSION },
    );
  },

  cancelTablesValidities(freightTableIds) {
    return apiClient.post(
      BATCH_CANCEL_URL,
      { vig: freightTableIds.map((id) => ({ id: Number(id) })) },
      { apiVersion: API_VERSION },
    );
  },

  listSuppliers(search) {
    return apiClient.post(
      "/api/pessoa/jsonlist/fornecedor",
      { params: [], search, statusRecord: [], status: 1 },
      { apiVersion: API_VERSION },
    );
  },

  // Busca de cliente/tomador: mesma rota da tela legada, sem filtro de papel — `pessoa` só tem
  // flag de fornecedor, cliente é papel na tabela de frete. Devolve items (PJ), itemsF (PF) e
  // itemsE (exterior).
  listClients(search) {
    return apiClient.post(
      "/api/pessoa/jsonlist",
      { params: [], search, statusRecord: [], status: 1 },
      { apiVersion: API_VERSION },
    );
  },

  storeSuppliers(tabfreId, payload) {
    return apiClient.post(
      RESOURCE_URL + `/store-first/${tabfreId}/pessoas`,
      payload,
      {
        apiVersion: API_VERSION,
      },
    );
  },

  updateSuppliers(tabfreId, payload) {
    return apiClient.put(
      RESOURCE_URL + `/store-first/${tabfreId}/pessoas`,
      payload,
      {
        apiVersion: API_VERSION,
      },
    );
  },

  fetchHistory(tabfreId, params) {
    return apiClient.get(RESOURCE_URL + `/${tabfreId}/historico`, {
      params,
      apiVersion: API_VERSION,
    });
  },

  storeRoutes(tabfreId, payload) {
    return apiClient.patch(RESOURCE_URL + `/storerota/${tabfreId}`, payload, {
      apiVersion: API_VERSION,
    });
  },

  storeRouteValidity(routeId, payload) {
    return apiClient.post(RESOURCE_URL + `/rota/${routeId}/vigencia`, payload, {
      apiVersion: API_VERSION,
    });
  },

  updateCarriers(tabfreId, payload) {
    return apiClient.patch(
      RESOURCE_URL + `/updatetransp/${tabfreId}`,
      payload,
      {
        apiVersion: API_VERSION,
      },
    );
  },

  approveValidities(validityIds) {
    return apiClient.post(
      VALIDITY_APPROVE_URL,
      { tabfrerotvig_id: validityIds },
      { apiVersion: API_VERSION },
    );
  },

  cancelValidities(validityIds) {
    return apiClient.post(
      VALIDITY_CANCEL_URL,
      { tabfrerotvig_id: validityIds },
      { apiVersion: API_VERSION },
    );
  },

  updateCarriersStatus(carrierIds, status) {
    return apiClient.patch(
      RESOURCE_URL + "/statustransp",
      { statusRecord: carrierIds, status },
      { apiVersion: API_VERSION },
    );
  },

  importRoutesSpreadsheet(file) {
    const formData = new FormData();
    formData.append("file", file);

    return apiClient.post(RESOURCE_URL + "/rota/importar", formData, {
      apiVersion: API_VERSION,
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  // Planilha de 83 colunas. Sem `tabfre_id` é o modelo em branco; com ele, a tabela preenchida
  // — com roteiro, no layout que a importação lê de volta. É o "Exportar csv" da listagem: o
  // export legado (`POST /exportar`) não tem roteiro, e o arquivo dele não voltava.
  downloadRoutesSpreadsheet(params = {}) {
    return apiClient.get(RESOURCE_URL + "/rota/planilha", {
      params,
      apiVersion: API_VERSION,
      responseType: "blob",
    });
  },
};
